// Components
import { IconFilter, IconCloseFat } from '@tracklib/kit'
import { SelectedOptions } from 'components/filter/filters/sliderdropdown/sliderdropdown'

import styles from './header.css'

type HeaderProps = {
  activeFilters: number
  toggleMobileFilterVisible: (state: boolean) => void
  onClear: () => void
}

const Header = ({ activeFilters, toggleMobileFilterVisible, onClear }: HeaderProps): JSX.Element => (
  <header className={styles.header}>
    <p>
      <IconFilter className={styles.filterIcon} /> Filter
    </p>
    <SelectedOptions count={activeFilters} className={styles.count} onClear={onClear} />
    <button onClick={() => toggleMobileFilterVisible(false)} className={styles.closeButton}>
      <IconCloseFat />
    </button>
  </header>
)

export default Header
